import { FC } from 'react'
import TProps from './types'
import AmountPreview from '../amount-preview'

const ERC20TokenPreview: FC<TProps> = ({
  image,
  amount,
  tokenAddress,
  name,
  chainId,
  tokenType,
  ethPrice,
  decimals,
  maticPrice
}) => {
  return <AmountPreview
    finished
    amount={amount}
    image={image}
    chainId={chainId}
    decimals={decimals}
    name={name}
    tokenType={tokenType}
    tokenAddress={tokenAddress}
    ethPrice={ethPrice}
    maticPrice={maticPrice}
  />
}

export default ERC20TokenPreview